import { render, staticRenderFns } from "./GasConsumptionWrapper.vue?vue&type=template&id=4f4d3af5&"
import script from "./GasConsumptionWrapper.vue?vue&type=script&lang=ts&"
export * from "./GasConsumptionWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports